export default "__VITE_ASSET__ySLMf$IC__"